import React, { FC } from "react";
import { ExternalChatMessage } from "domain-entities";
import LoadingIndicator from "Components/Layout/LoadingIndicator";
import ErrorView from "Components/Layout/ErrorView";
import { Box, makeStyles } from "@material-ui/core";
import { useMessageMedia } from "Components/Message/MessageHelper";

interface Props {
  message: ExternalChatMessage;
}

const GalleryImage: FC<Props> = (props) => {
  const classes = useStyles();
  const messageMedia = useMessageMedia(props.message);

  if (messageMedia.isLoading) {
    return <LoadingIndicator />;
  } else if (messageMedia.error) {
    return <ErrorView error={messageMedia.error} />;
  } else if (messageMedia.url) {
    return (
      <Box className={classes.root}>
        <img
          className={classes.img}
          alt={props.message.media?.name}
          src={messageMedia.url}
        />
      </Box>
    );
  } else {
    return <ErrorView error={new Error("Can not find download URL.")} />;
  }
};

export default GalleryImage;

const useStyles = makeStyles({
  root: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  img: {
    with: "auto",
    height: "auto",
    maxWidth: "100%",
    maxHeight: "100%",
  },
});
